import styled, { css } from "styled-components";
import Media from "../../utils/media";

export const AppBarItem = styled.div`
  padding: 10px 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
`;

export const AppBarSpacer = styled(AppBarItem)`
  ${Media.phone`display: none;`};
  ${Media.desktop`display: flex;`};
  flex: 1;
  // same max width as the arrow box, but we should change this when we go grid.
  max-width: 7rem;
  flex-basis: auto;
`;

export const PickerContainer = styled.div`
  position: static;
  ${Media.tablet`position: relative`};
  flex: 1 0 20%;
  display: flex;
  max-width: calc(100vw - 74px);
  direction: ${props =>
    props.theme.scriptDirection === "rtl" ? "rtl" : "ltr"};
  align-items: center;
  justify-content: left;
`;

export const PickerGroup = styled.div`
  display: flex;
  flex: 0 1 auto;
  min-height: 44px;
  border: 1px solid ${props => (props.theme.darkMode ? "#5D5D5D" : "#DCDCDC")};
  border-radius: 28px;
  background: ${props =>
    props.theme.darkMode ? props.theme.computedPrimary : "white"};
  box-shadow: 1px 3px 3px rgba(0, 0, 0, 0.05);
  padding: 0 8px;
  flex-direction: row;
  // This doesn't feel very React-y.
  .close-parallel {
    transition: all 0.5s ease;
    color: #dcdcdc;
    cursor: pointer;
    &:hover {
      color: ${({ theme }) =>
        theme.darkMode ? theme.textOnPrimary : theme.computedPrimary};
    }
  }
`;

export const StyledItem = styled(AppBarItem)`
  color: ${props => (props.theme.darkMode ? "white" : "#111")};
  border: none;
  background: none;
`;

export const StyledButtonItem = styled.button`
  position: relative;
  padding: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: ${props => (props.theme.darkMode ? "white" : "#111")};
  border: none;
  background: none;
  cursor: pointer;

  &:focus {
    outline: 0;
  }
`;

const dividerLeft = css`
  border-right: solid 1px
    ${props => (props.theme.darkMode ? "#5D5D5D" : "#DCDCDC")};
  border-left: 0px;
  padding: 10px 12px;
  margin: 0 8px 0 0;
`;

const dividerRight = css`
  border-right: 0px;
  border-left: solid 1px
    ${props => (props.theme.darkMode ? "#5D5D5D" : "#DCDCDC")};
  padding: 10px 12px;
  margin: 0 0 0 8px;
`;

export const SearchButtonItem = styled(StyledButtonItem)`
  ${props =>
    props.theme.scriptDirection === "rtl" ? dividerRight : dividerLeft};
`;

export const ParrallelButtonItem = styled(StyledButtonItem)`
  ${props =>
    props.theme.scriptDirection === "rtl" ? dividerLeft : dividerRight};
`;
